import { Body, Controller, Post, UploadedFiles, UseInterceptors } from "@nestjs/common";
import { ApiBody, ApiConsumes, ApiOperation, ApiResponse, ApiTags } from "@nestjs/swagger";
import { StyleService } from "./style-service";
import { StyleCreateRequest, StyleModel, StyleResponse } from "@needle-management/shared-models";
import { CommonResponseModel } from "@needle-management/shared-models";




@ApiTags('Style')
@Controller('style')
export class StyleController {
  constructor(
    private service: StyleService,
  ) { }

  @Post('createStyle')
  @ApiBody({ type: StyleCreateRequest })
  async createStyle(@Body() req: StyleCreateRequest): Promise<StyleResponse> {
    try {
      return await this.service.createStyle(req);
    } catch (error) {
      throw error
    }
  }

   @Post('updateStyle')
  @ApiBody({ type: StyleModel })
  async updateStyle(@Body() req: StyleModel): Promise<StyleResponse> {
    try {
      return await this.service.updateStyle(req);
    } catch (error) {
      throw error
    }
  }

  @Post('deleteStyle')
  @ApiBody({ type: StyleModel })
  async deleteStyle(@Body() req: StyleModel): Promise<StyleResponse> {
    try {
      return await this.service.deleteStyle(req);
    } catch (error) {
      throw error
    }
  }

  @Post('getAllStyles')
  @ApiBody({ })
  async getAllStyles(): Promise<StyleResponse> {
    try {
      return await this.service.getAllStyles();
    } catch (error) {
      throw error
    }
  }
  @Post('activateDeactivateStyle')
  @ApiBody({ type: StyleModel })
  async activateDeactivateStyle(@Body() req: StyleModel): Promise<StyleResponse> {
    try {
      return await this.service.activateDeactivateStyle(req);
    } catch (error) {
      throw error
    }
  }


  @Post('getActiveStyles')
  async getActiveStyles(): Promise<CommonResponseModel> {
    try {
      return await this.service.getActiveStyles();
    } catch (error) {
      throw error
    }
  }

    
}